export enum ExternalResource {
  Intercom = "intercom",
}
